<template>
  <div>
    <User />
    <Shortcuts v-if="showShortcuts()" />
    <History v-if="showHistory()" />
  </div>
</template>

<script>
export default {
  methods: {
    showShortcuts() {
      let shortcuts = false
      if (this.authorized.sessions && this.authorized.sessions.create) shortcuts = true
      if (this.authorized.presentations && this.authorized.presentations.create) shortcuts = true
      if (this.authorized.persons && this.authorized.persons.create) shortcuts = true
      return shortcuts
    },
    showHistory() {
      let history = false
      if (this.authorized.sessions && this.authorized.sessions.create) history = true
      if (this.authorized.presentations && this.authorized.presentations.create) history = true
      if (this.authorized.persons && this.authorized.persons.create) history = true
      return history
    }
  },
}
</script>